import React, {useEffect, useState} from 'react';
import TeacherLayout from "@/components/layout/teacher/teacherLayout";
import {URLS} from "@/lib/urls";
import FreeBox from "@/components/box/freeBox";
import {useApiCreateTeacherReports, useApiSearchTeacherReportsTypes} from "@/api/teacherReports";
import {Alert, Button, Select, TimePicker, Input} from "antd";
import RenderLoading from "@/components/render-if-loading";
import toFaNumber from "@/lib/utils/number";
import {useApiSearchTeacherLessons} from "@/api/lesson";
import {DatePicker} from "antd-jalali";
import dayjs from "dayjs";
import TextArea from "antd/lib/input/TextArea";
import {SaveIcon} from "lucide-react";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import {useNavigate} from "react-router-dom";
import UploadCMP from "@/components/upload";


function TeacherReportCreatePage() {
    const [typeId, setTypeId] = useState()
    const [myDate, setMyDate] = useState()
    const [startTime, setStartTime] = useState()
    const [endTime, setEndTime] = useState()
    const [reportText, setReportText] = useState()
    const [lesson, setLesson] = useState()
    const navigate = useNavigate();
    const [fileId, setFileId] = useState('')


    const {data: teacherReportsTypes, isPending: isPendingTypes} = useApiSearchTeacherReportsTypes();
    const {mutate: createTeacherReport, isPending: isPendingSaveTeacherReport} = useApiCreateTeacherReports()
    const {data: lessonList, isPending: isPendingLessonList} = useApiSearchTeacherLessons({per_page: 1000});

    useEffect(() => {
        if (!myDate) {
            setMyDate(dayjs(Date.now()).calendar("gregory"))
        }
    })

    function saveReport() {
        createTeacherReport({
                type_id: typeId,
                date: myDate,
                file_id: fileId,
                start_time: startTime,
                end_time: endTime,
                lesson_id: lesson,
                report: reportText,
            },
            {
                onSuccess: (r) => {
                    ApiHandleSuccessMessage(r)
                    setFileId('')
                    navigate(URLS.teacher.reports.dashboard)

                },
                onError: (r) => {
                    ApiHandleErrorMessage(r)
                }
            })
    }

    return (
        <TeacherLayout pageTitle={'ثبت گزارش عملکرد'} backTo={URLS.teacher.reports.dashboard}>
            <FreeBox>
                <Alert message={'ثبت گزارش فعالیت'}
                       description={'لطفا موارد درخواست شده را با دقت تکمیل کنید و گزارش فعالیت خود را ارسال نمایید.'}
                       showIcon={true}
                       type={'info'}
                />
                <div className={'mb-1'}>نوع فعالیت</div>
                <RenderLoading loading={isPendingTypes}>
                    <Select

                        className={'w-full'}
                        value={typeId}
                        onChange={(e) => setTypeId(e)}
                        placeholder={'لطفا یگی از گزینه‌ها را انتخاب کنید'}
                    >

                        {teacherReportsTypes?.data?.data.map(t => (
                            <Select.Option key={t.id + 'report-types'} value={t.id}>
                                {t.title}
                            </Select.Option>
                        ))}
                    </Select>
                </RenderLoading>
                <div className={'mb-1'}>
                    <div className={'mb-1'}>انتخاب درس</div>
                    <RenderLoading loading={isPendingLessonList}>
                        <Select

                            className={'w-full'}
                            value={lesson}
                            onChange={(e) => setLesson(e)}
                            placeholder={'لطفا یگی از گزینه‌ها را انتخاب کنید'}
                        >
                            <Select.Option value={null}>سایر</Select.Option>
                            {lessonList?.data?.data.map(t => (
                                <Select.Option key={t.id + 'report-types'} value={t.id}>
                                    {toFaNumber(t.code) + ' - ' + (t?.topic?.title ?? '') + ' - ' + (t?.title ?? '')}

                                </Select.Option>
                            ))}
                        </Select>
                    </RenderLoading>
                </div>

                <div className="flex flex-wrap gap-2">
                    <div>
                        <span>تاریخ فعالیت</span>
                        <div>
                            <DatePicker
                                format="YYYY/MM/DD"
                                value={
                                    myDate
                                        ? dayjs(myDate).calendar("jalali")
                                        : dayjs().calendar("jalali")
                                }
                                onChange={(d) => setMyDate(d ? d.calendar("gregory").format("YYYY-MM-DD") : null)}
                            />
                        </div>
                    </div>
                    <div>
                        <span className={'mx-1'}>زمان شروع</span>
                        <div>
                            <TimePicker
                                onChange={(time) => {
                                    setStartTime(time ? time.format('HH:mm') : null)
                                }}
                                format={'HH:mm'}/>
                        </div>
                    </div>
                    <div>
                        <span className={'mx-1'}>زمان پایان</span>
                        <div>
                            <TimePicker
                                onChange={(time) => {
                                    setEndTime(time ? time.format('HH:mm') : null)
                                }}
                                format={'HH:mm'}/>
                        </div>
                    </div>
                </div>

                <div className={'my-1'}>
                    <div>متن گزارش</div>
                    <Input.TextArea onChange={(e) => setReportText(e.target.value)} rows={5}
                              placeHolder={'متن گزارش خود را اینجا بنویسید ...'}></Input.TextArea>
                </div>
                <div className={'my-1'}>
                    بارگزاری فایل ضمیمه (‌اختیاری)
                    <UploadCMP dragMode={true}
                               afterUploadFn={(a) => {

                                   setFileId(a?.file?.response?.data?.id)
                               }}/>
                </div>
                <div className={'flex justify-between'}>
                    <div></div>
                    <div>
                        <Button
                            loading={isPendingSaveTeacherReport}
                            onClick={saveReport}
                            variant={'solid'}
                            color={'primary'}
                            icon={<SaveIcon/>}
                            size={'large'}>ارسال گزارش</Button>
                    </div>
                </div>
            </FreeBox>
        </TeacherLayout>
    );
}

export default TeacherReportCreatePage;